import * as Yup from 'yup';
import RULES from '@/assets/js/validRules';

export default Yup.object({
  topic: RULES.required,
  name: RULES.required,
  companyName: RULES.required,
  email: RULES.email,
  phone: RULES.required,
  accept: RULES.accept,
});
